module.exports = __webpack_public_path__ + "img/advanced_attention.0b504f4c.png";